import { makeStyles, Theme } from "@material-ui/core";
import { observer } from "mobx-react";
import { Paper, PaperBorderType } from "@roc/ui";
import { useDocumentStore } from "@roc/feature-documents";
import { PayoffCard } from "./cardComponents/payoffCard";

const useStyles = makeStyles((theme: Theme) => ({
  borderColor: {
    borderColor: `${theme.palette.primary.main} !important`,
  },
  headerStyle: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.getContrastText(theme.palette.primary.main),
    borderColor: theme.palette.primary.main,
    borderRadius: '14px 14px 0px 0px',
  }
}));

export const PayoffFinalCard = observer(({ }) => {
  const classes = useStyles();
  const {
    documentStore: {
      documentFormStore: { payoffCalculatorStore },
    },
  } = useDocumentStore();

  return (
    <Paper
      title='Final'
      titleClass={classes.headerStyle}
      borderType={PaperBorderType.SOLID_BORDER}
      className={classes.borderColor}
    >
      <PayoffCard
        columns={[
          {
            label: 'Name',
            value: 'name',
            width: '50%'
          },
          {
            label: 'Amount',
            value: 'amount',
            type: 'currency',
            width: '50%'
          }
        ]}
        rows={payoffCalculatorStore?.finalTotals}
        total={payoffCalculatorStore?.finalTotal}
      />
    </Paper>
  );
});